// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const necrozma_dusk: PokeData = {
  "id": 10155,
  "name": "necrozma-dusk",
  "height": 38,
  "weight": 4600,
  "base_experience": 340,
  "types": [
    PokeType.PSYCHIC,
    PokeType.STEEL
  ],
  "api_moves": [
    "confusion",
    "slash",
    "metal-claw",
    "morning-sun",
    "moonlight",
    "iron-defense",
    "rock-blast",
    "gravity",
    "wring-out",
    "night-slash",
    "power-gem",
    "psycho-cut",
    "mirror-shot",
    "stealth-rock",
    "charge-beam",
    "autotomize",
    "stored-power",
    "prismatic-laser",
    "photon-geyser"
  ],
  "moves": [
    "metal-claw",
    "morning-sun",
    "moonlight",
    "rock-blast",
    "night-slash",
    "stealth-rock",
    "smart-strike",
    "zen-headbutt",
    "magnet-bomb",
    "kinesis",
    "psy-pulse",
    "psychic-fangs",
    "metal-burst"
  ],
  "evolution_chain": {
    "id": 421,
    "item": null,
    "species": [
      {
        "name": "necrozma",
        "order": 800,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 90,
    "ability_power": 184
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
